import { adjustEnding, formatCardKey, removeTrailingDot } from '@/ai/utils/helpers'

export const getCardTypeInstruction = (cardType, prefix) => {
  if (!cardType.generateWithAI) {
    return ''
  }

  return `${prefix || ''}${adjustEnding(cardType.title, 1)}: ${removeTrailingDot(cardType.description)} (as ${formatCardKey(cardType.title)}). `
}

export const readModelNotes = [
  `Avoid adding ID fields to the read model. For example, avoid "Customer ID". Instead, use "Customer".
   It will be understood that a join with the customer table is needed (or a subquery)`,
  'Exclude backticks when generating the JSON output',
  `The Read Model is a query that provides a view of the system state BEFORE the actor invokes the
   state-changing command. For example, if the command is "CreateProduct" and the entity
   is "Product", the Product ID does not exist at this point in time and cannot be included in
   the query unless it is picked up from another system`,
  `The Read Model is a query that gives the actor background information necessary to make decisions,
   fill in the input form and submit it (Salesperson - Created lead)`
]
